import React, { useState, useRef, useEffect } from 'react'
import { message } from 'antd'
import Modal from 'meinian-package/src/component/modal'
import Input from 'meinian-package/src/baseComponent/input'
import Switch from 'meinian-package/src/baseComponent/switch'
import Icon from 'meinian-package/src/component/icon'
import request from 'meinian-package/src/utils/request'
import Button from 'meinian-package/src/baseComponent/button'
import { SHARE_TYPE } from 'common/config/enum'
import './index.less'

const updateShareStatus = async (params) => {
  try {
    await request.get('/zhikuan/ins/inspiration/update-receive-status', { params })
  } catch (err) {
    console.error(err)
  }
}

const Receive = () => {
  return <div className="meinian-coll-share">
    <div className="icon"><Icon type="m-lianjie" /></div>
    <div className="text">开启后，其他人可通过链接领取该灵感集到自己的美念账户</div>
  </div>
}

export const Receiving = (props) => {
  const { inspirationId, name, onChange } = props
  const [shareUrl, setShareUrl] = useState('')
  const [receiveStatus, setReceiveStatus] = useState(true)
  const $link = useRef()
  useEffect(() => {
    fetchUrl()
  }, [inspirationId])
  const fetchUrl = async () => {
    try {
      const res = await request.get('/ins/inspiration/generate-share-url', { params: { inspirationId, shareType: SHARE_TYPE.RECEIVE } }) // 1: 分享链接 2: 领取
      setShareUrl(`【知衣科技】${window.location.protocol}//${window.location.host}/meinian/receive?shareUrl=${res}，点击链接，领取灵感集《${name}》`)
    } catch (e) {
      console.error(e)
    }
  }
  const onCopy = () => {
    $link.current.$input.select()
    if (document.execCommand('copy')) {
      document.execCommand('copy')
      message.success('复制成功')
    } else {
      message.error('该浏览器不支持复制功能')
      console.error('该浏览器不支持复制功能')
    }
  }
  return <div className="meinian-coll-sharing">
    <div className="des">获得链接的人即可领取该灵感集到自己的美念账户</div>
    <Input
      readonly
      ref={$link}
      value={shareUrl}
      suffix={<Button style={{ marginLeft: 16 }} disabled={!shareUrl} onClick={() => onCopy()}>复制链接</Button>}
    />
    <div className="tip">复制链接后，可分享至微信或钉钉</div>
    <div className="foot-switch">
      <span>关闭领取&nbsp;&nbsp;</span>
      <Switch
        active={receiveStatus}
        onChange={async (val) => {
          await updateShareStatus({ inspirationId: props.inspirationId, receiveStatus: val ? 1 : 0 })
          setReceiveStatus(val)
          onChange && onChange(val)
        }}
      />
      <i>关闭后该链接将无法领取灵感集</i>
    </div>
  </div>
}

Receive.show = (props) => {
  const { onChange } = props
  Modal.confirm({
    title: '灵感集领取链接',
    children: <Receive />,
    confirmText: '开启领取',
    onOk: async () => {
      await updateShareStatus({ inspirationId: props.inspirationId, receiveStatus: 1 })
      Receiving.show(props)
      onChange && onChange(true)
    }
  })
}

Receiving.show = (props) => {
  Modal.info({
    title: '灵感集领取链接',
    hiddenFooter: true,
    children: <Receiving {...props} />,
  })
}
export default Receive
